import {state as lifecycle} from 'fragments/lifecycle';

export default {
	...lifecycle,
	loading: false,
	redirect: null,
};
